export enum NotifyType {
    SUCCESS= 0,
    ERROR = 1,
    WARNING = 3,
    INFO=4
}
